<template>
    <div id="project-details" class="padded">
      {{ loadingError }}
        <header class="header-with-buttons">
            <h2 class="display-6 project-block-header">{{ projectdata.Name }}</h2>
        </header>
        <p class="display-7">{{ projectdata.Description }}</p>
        <p>Members:</p>
        <loader v-if="loading"/>
        <ul>
          <li v-for="member in projectmembers">
            {{member.username}}
          </li>
          <li><button class="textonly" @click="showModal = true">Invite someone</button></li>
        </ul>
                
        <modal v-if="showModal" @close="showModal = false" title="Invite members">
            <form @submit.prevent="addMember">
                <transition name="fade">
                    <alert-bar v-if="msgtext" v-bind:class="msgclass">{{msgtext}}</alert-bar>
                </transition>
                <input-default label="Username" v-model="inviteUsername"/>
                <input-default label="Email" v-model="inviteEmail"/>
                <input-default label="Password" v-model="invitePass"/>
                <button class="button" type="submit">Invite</button>
            </form>
        </modal>
    </div>
</template>

<script>
  import Loader from '../ui/Loader.vue'
  import InputDefault from '../form/InputDefault.vue'
  import Modal from '../modal/Modal.vue'
  import axios from 'axios'

  export default {
    components: {
      Loader,
      InputDefault,
      Modal
    },
    data () {
        return {
            projectdata: {},
            projectmembers: {},
            loading: true,
            loadingError: '',
            inviteUsername: '',
            inviteEmail: '',
            invitePass: '',
            addedUser: {},
            showModal: false,
            token: JSON.parse(localStorage.getItem('user')).id,
            memberId: JSON.parse(localStorage.getItem('user')).userId
        }
    },
    methods: {
      getProjectData(){
          axios.get(process.env.VUE_APP_ROOT_API+'/members/'+this.memberId+'/Projects/'+this.$route.params.projectid+'?access_token='+this.token)
          .then(response => {
              this.projectdata = response.data
              this.loading = false
          })
          .catch(function (error) {
            if (error.response.status === 401) {
              console.log(error.response.statusText)
              this.loadingError = error.response.statusText
            }
          });
      },
      addMember(){
          const data = {
              username: this.inviteUsername,
              email: this.inviteEmail,
              password: this.invitePass
          }

          axios.post(process.env.VUE_APP_ROOT_API+'/Members?access_token='+this.token, data)
          .then(response => {
              this.addedUser = response.data
              this.addMemberToProject(this.addedUser.id)
          })
      },
      addMemberToProject(memberId){

          const data = {
              memberId: memberId,
              projectId: this.$route.params.projectid
          }

          axios.post(process.env.VUE_APP_ROOT_API+'/ProjectMembers?acces_token='+this.token, data)
          .then(response => {
              console.log(response.data)
              this.getProjectMembers()
              this.showModal = false
          })
      },
      getProjectMembers(){
          axios.get(process.env.VUE_APP_ROOT_API+'/Projects/'+this.$route.params.projectid+'/members?access_token='+this.token)
          .then(response => {
              this.projectmembers = response.data
              this.loading = false
          })
      }
    },
    mounted() {
      this.getProjectData();
      this.getProjectMembers();
    },
    watch: {
        '$route' (to, from) {
            this.loading = true
            this.getProjectData()
            this.getProjectMembers()
        }
    }
  }
</script>